import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import { Button, Modal, Form, Row, Col, Card, Nav, Tab, Badge } from 'react-bootstrap';
import { FaSync, FaUpload, FaTimes, FaExpand, FaCompress } from 'react-icons/fa';
import { getReceipts, getReceiptsByID, archiveReceipts, undoArchiveReceipts, deleteReceipts } from "apiServices/reducer/apiService";
import { UploadReciepts } from "pageComponents";
import './receipts.css';
import { ReportDisplaySection, CustomSuccessModal } from "components";
import { getReportDownloadFilename } from "../../../utils/utils";
import { showPmrDeleteConfirm } from "../../../utils/swalUtils";

const SEARCH_DEBOUNCE_MS = 500;
const SEARCH_MIN_CHARS = 3;

const Receipts = (props) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [shouldRefetchAfterClear, setShouldRefetchAfterClear] = useState(false);
    const searchDebounceRef = useRef(null);
    const searchRequestIdRef = useRef(0);
    const searchWasActiveRef = useRef(false);
    const [activeTab, setActiveTab] = useState('All');
    const [rowData, setRowData] = useState([]);
    const [togglePDF, setTogglePDF] = useState(false);
    //const [columnDefs, setColumnDefs] = useState([]);   
    const [rowDatanew, setRowDatanew] = useState([]);
    const token = useSelector((state) => state.apiService.token);
    const userData = useSelector((state) => state.apiService.login);
    const [pdfBlob, setPdfBlob] = useState(null); // State to store the fetched blob
    const [contentType, setContentType] = useState(null); // State to store the content type
    const [receiptId, setReceiptId] = useState(null);
    const [showUploadReciepts, setShowUploadReciepts] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const [includeArchivedforReceipts, setIncludeArchivedforReceipts] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showDeleteSuccessModal, setShowDeleteSuccessModal] = useState(false);
    const [showUnarchiveSuccessModal, setShowUnarchiveSuccessModal] = useState(false);
    const [isReceipts, setIsReceipts] = useState(false);
    const [isReportPreviewLoading, setIsReportPreviewLoading] = useState(false);
    const [downloadReceiptparams, setDownloadReceiptParams] = useState(
        {
            token: token,
            UserID: userData.user_id,
            ReceiptID: null,
            ReceiptDate: null,
        }
    );
    const [archiveReceiptParams, setArchiveReceiptParams] = useState(
        {
            token: token,
            UserID: userData.user_id,
            receiptId: ""
        }
    );
    const isRowArchived = (params) => !!params.data?.is_archived;
    const columnDefs = [
        {
            headerName: "Receipt Name",
            field: "receipt_name",
            flex: 2,
            sortable: true,
            filter: true,
            tooltipField: "receipt_name",
            headerTooltip: "Receipt Name",
            cellStyle: (params) => ({
                color: isRowArchived(params) ? '#ff0000' : 'black',
                fontWeight: '400',
                fontSize: '14px',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                maxWidth: '250px',
                display: 'inline-block',
                verticalAlign: 'middle'
            }),
        },
        {
            headerName: "Receipt Date",
            field: "date",
            flex: 1,
            sortable: true,
            filter: true,
            tooltipField: "date",
            headerTooltip: "Receipt Date",
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold" }}>{params.value}</span>
            ),// Render bold text using React
            cellStyle: (params) => ({
                color: isRowArchived(params) ? '#ff0000' : 'black',
                fontWeight: '400',
                fontSize: '14px',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                maxWidth: '250px',
                display: 'inline-block',
                verticalAlign: 'middle'
            }),
        },
        {
            headerName: "Bill Value",
            field: "bill_value",
            flex: 1,
            sortable: true,
            filter: true,
            tooltipField: "bill_value",
            headerTooltip: "Bill Value",
            cellRendererFramework: (params) => (
                <span style={{ fontWeight: "bold" }}>{params.value}</span>
            ),// Render bold text using React
            cellStyle: (params) => ({
                color: isRowArchived(params) ? '#ff0000' : 'black',
                fontWeight: '400',
                fontSize: '14px'
            }),
        },
        {
            headerName: "Clinic/Diagnostics Center",
            field: "hospital_name",
            flex: 2,
            sortable: true,
            filter: true,
            tooltipField: "hospital_name",
            headerTooltip: "Clinic/Diagnostics Center",
            cellStyle: (params) => ({
                color: isRowArchived(params) ? '#ff0000' : 'black',
                fontWeight: '400',
                fontSize: '14px',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                maxWidth: '250px',
                display: 'inline-block',
                verticalAlign: 'middle'
            }),
        },
    ];

    const formatReceiptsData = useCallback((fetchedData, totalAmountTable) => {
        if (totalAmountTable?.length) {
            const amount = totalAmountTable.map((item) => item.total_bill_value);
            setTotalAmount(amount);
        } else {
            setTotalAmount(0);
        }

        return (fetchedData || []).map((report) => ({
            receipt_name: report.receipt_name,
            date: report.receipt_date,
            bill_value: report.bill_value,
            hospital_name: report.hospital_name,
            receiptId: report.receipt_id,
            is_archived: report.is_archieved ?? report.is_archived,
            provider_name: report.provider_name,
        }));
    }, []);

    const applyReceiptsResponse = useCallback((resp) => {
        if (resp.payload !== null && resp.payload !== undefined && resp.payload !== "") {
            const formattedData = formatReceiptsData(resp.payload.Table, resp.payload.Table1);
            setRowData(formattedData);
            setRowDatanew(formattedData);
            setIsReceipts(true);
        } else {
            setRowData([]);
            setRowDatanew([]);
            setTotalAmount(0);
        }
    }, [formatReceiptsData]);

    const onSearch = (e) => {
        handleClear();
        const searchValue = e.target.value;
        setSearchQuery(searchValue);

        const effectiveUserId = selectedUserId;

        const updatedReceiptsData = {
            ...receiptsData,
            SearchKey: searchValue,
            UserID: effectiveUserId,
            token: token,
        };
        const updatedArchivedReceiptsData = {
            ...archivedReceiptsData,
            SearchKey: searchValue,
            UserID: effectiveUserId,
            token: token,
        };

        setReceiptsData(updatedReceiptsData);
        setArchivedReceiptsData(updatedArchivedReceiptsData);

        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
            searchDebounceRef.current = null;
        }

        if (searchValue.trim().length < SEARCH_MIN_CHARS) {
            searchRequestIdRef.current += 1;
            if (searchWasActiveRef.current) {
                searchWasActiveRef.current = false;
                setReceiptsData({
                    ...updatedReceiptsData,
                    SearchKey: '',
                });
                setArchivedReceiptsData({
                    ...updatedArchivedReceiptsData,
                    SearchKey: '',
                });
                setRowData([]);
                setRowDatanew([]);
                setShouldRefetchAfterClear(true);
            }
            return;
        }

        searchWasActiveRef.current = true;
        const searchRequestId = searchRequestIdRef.current + 1;
        searchRequestIdRef.current = searchRequestId;

        searchDebounceRef.current = setTimeout(() => {
            searchDebounceRef.current = null;
            setRowData([]);
            setRowDatanew([]);

            const requestPayload = includeArchivedforReceipts
                ? { ...updatedArchivedReceiptsData, IncludeArchived: true, token }
                : { ...updatedReceiptsData, IncludeArchived: false, token };

            dispatch(getReceipts(requestPayload)).then((resp) => {
                if (searchRequestId !== searchRequestIdRef.current) {
                    return;
                }
                applyReceiptsResponse(resp);
            });
        }, SEARCH_DEBOUNCE_MS);
    };

    const onClear = () => {
        if (searchDebounceRef.current) {
            clearTimeout(searchDebounceRef.current);
            searchDebounceRef.current = null;
        }
        searchRequestIdRef.current += 1;
        searchWasActiveRef.current = false;

        setSearchQuery('');

        setReceiptsData((prev) => ({
            ...prev,
            SearchKey: '',
            UserID: selectedUserId,
            token: token,
        }));
        setArchivedReceiptsData((prev) => ({
            ...prev,
            SearchKey: '',
            UserID: selectedUserId,
            token: token,
        }));

        setRowData([]);
        setRowDatanew([]);
        setShouldRefetchAfterClear(true);
    };

    const handleSearchClear = () => {
        handleClear();
        onClear();
    };

    const onRefresh = () => {
        handleClear();
        if (includeArchivedforReceipts) {
            fetchArchivedReceipts();
        } else {
            fetchReceipts();
        }
    };
    const onRowClicked = (event) => {
        console.log(event.data, "event.data")
        setSelectedRow(event.rowIndex)
        const params = {
            UserID: selectedUserId,
            ReceiptID: event.data.receiptId,
            token: token
        }
        setReceiptId(event.data.receiptId);
        // Clear previous blob and URL
        setPdfBlob(null);
        setPdfUrl(null);
        setContentType(null);
        setIsReportPreviewLoading(true);
        setSelectedReport(event.data);

        // Set parameters for potential download later (though we won't use them directly in downloadReceipt now)
        setDownloadReceiptParams(
            {
                token: token,
                UserID: selectedUserId,
                ReceiptID: event.data.receiptId,
            }
        );
        setArchiveReceiptParams(
            {
                token: token,
                UserID: selectedUserId,
                receiptId: event.data.receiptId
            }
        );

        dispatch(getReceiptsByID(params)).then((resp) => {
            console.log("resp preview fetch:", resp);
            console.log("Type of resp.payload:", typeof resp.payload);
            console.log("Is resp.payload a Blob?", resp.payload instanceof Blob);
            console.log("resp.payload content (first 100 bytes if Blob):", resp.payload instanceof Blob ? resp.payload.slice(0, 100) : resp.payload);

            if (resp.payload && resp.payload instanceof Blob) {
                const blob = resp.payload;
                setPdfBlob(blob); // Store the fetched blob
                setContentType(blob.type); // Store the content type
                const blobUrl = URL.createObjectURL(blob);
                console.log('bloburl for preview', blobUrl)
                console.log('content type:', blob.type)
                setPdfUrl(blobUrl);
                setSelectedReport(event.data);
            } else {
                console.error("Failed to fetch PDF blob or invalid format. Payload:", resp.payload);
                setPdfBlob(null);
                setPdfUrl(null);
                setContentType(null);
                // Handle error appropriately, e.g., show a message to the user
            }
        }).catch(error => {
            console.error("Error fetching receipt by ID:", error);
            setPdfBlob(null);
            setPdfUrl(null);
            // Handle error appropriately
        }).finally(() => {
            setIsReportPreviewLoading(false);
        });
    };
    const gridRef = useRef(null);
    const [selectedReport, setSelectedReport] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const dispatch = useDispatch();
    console.log(token, "tokenreceipt");
    const selectedUserId = props.selectedFamilyMember?.user_id || userData.user_id;
    const [receiptsData, setReceiptsData] = useState({
        token: token,
        UserID: selectedUserId,
        IncludeArchived: false,
        SearchKey: searchQuery,
        ReceiptDate: null,
        HospitalName: null
    });
    const [archivedReceiptsData, setArchivedReceiptsData] = useState({
        token: token,
        UserID: selectedUserId,
        IncludeArchived: true,
        SearchKey: searchQuery,
        ReceiptDate: null,
        HospitalName: null
    });
    const [isFullscreen, setIsFullscreen] = useState(false);
    const previewRef = useRef(null);
    const iframeRef = useRef(null);

    // Add handleClear function to clear preview state
    const handleClear = () => {
        setPdfUrl((prev) => {
            if (prev && typeof prev === 'string' && prev.startsWith('blob:')) {
                URL.revokeObjectURL(prev);
            }
            return null;
        });
        setSelectedReport(null);
        setSelectedRow(null);
        setPdfBlob(null);
        setContentType(null);
        setIsReportPreviewLoading(false);
        setReceiptId(null);
    };

    const handleFullScreenToggle = () => {
        const elem = previewRef.current;
        if (!elem) {
            return;
        }

        if (!document.fullscreenElement) {
            elem.requestFullscreen()
                .then(() => { })
                .catch(err => {
                    console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen()
                    .then(() => { })
                    .catch(err => {
                        console.error(`Error attempting to exit full-screen mode: ${err.message} (${err.name})`);
                    });
            } else {
                console.error("Exit fullscreen is not supported by this browser.");
            }
        }
    };

    const includeArchived = () => {
        setIncludeArchivedforReceipts(prev => !prev);
        console.log(includeArchivedforReceipts, "includeArchivedforReceipts")
        if (!includeArchivedforReceipts) {
            fetchArchivedReceipts();
        } else {
            fetchReceipts();
        }
    }

    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange); // Safari
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);    // Firefox
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);     // IE/Edge

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, []);

    useEffect(() => {
        const newUserId = props.selectedFamilyMember?.user_id || userData.user_id;

        setIncludeArchivedforReceipts(false);
        setSearchQuery('');
        setReceiptsData(prev => ({
            ...prev,
            UserID: newUserId,
            token: token,
            SearchKey: null,
            IncludeArchived: false,
        }));
        setArchivedReceiptsData(prev => ({
            ...prev,
            UserID: newUserId,
            token: token,
            SearchKey: null,
            IncludeArchived: true,
        }));
        setPdfBlob(null);
        setPdfUrl(null);
        setContentType(null);
        setSelectedReport(null);
        setSelectedRow(null);
        setReceiptId(null);

        fetchReceipts(newUserId);
    }, [props.selectedFamilyMember, token]);

    useEffect(() => {
        if (shouldRefetchAfterClear) {
            setShouldRefetchAfterClear(false);
            if (includeArchivedforReceipts) {
                fetchArchivedReceipts();
            } else {
                fetchReceipts();
            }
        }
    }, [shouldRefetchAfterClear, includeArchivedforReceipts]);

    useEffect(() => {
        return () => {
            if (searchDebounceRef.current) {
                clearTimeout(searchDebounceRef.current);
            }
        };
    }, []);

    const fetchReceipts = (overrideUserId) => {
        const effectiveUserId =
            overrideUserId ||
            props.selectedFamilyMember?.user_id ||
            receiptsData.UserID ||
            userData.user_id;

        const requestPayload = {
            ...receiptsData,
            UserID: effectiveUserId,
            token: token,
            IncludeArchived: false,
        };

        setRowData([]);
        setRowDatanew([]);
        setTotalAmount(0);
        setPdfBlob(null);
        setSelectedRow(null);

        setPdfUrl(null);
        setContentType(null);
        setIsReportPreviewLoading(false);
        setSelectedReport(null);
        dispatch(getReceipts(requestPayload)).then((resp) => {
            applyReceiptsResponse(resp);
        });
    }
    const fetchArchivedReceipts = (overrideUserId) => {
        const effectiveUserId =
            overrideUserId ||
            props.selectedFamilyMember?.user_id ||
            archivedReceiptsData.UserID ||
            userData.user_id;

        const requestPayload = {
            ...archivedReceiptsData,
            UserID: effectiveUserId,
            token: token,
            IncludeArchived: true,
        };

        setRowData([]);
        setRowDatanew([]);
        setTotalAmount(0);
        setPdfBlob(null);
        setPdfUrl(null);
        setSelectedRow(null);
        setContentType(null);
        setIsReportPreviewLoading(false);
        setSelectedReport(null);
        dispatch(getReceipts(requestPayload)).then((resp) => {
            applyReceiptsResponse(resp);
        });
    }
    const downloadReceipt = async () => {
        if (!pdfBlob) {
            console.error("No receipt blob available for download.");
            return;
        }

        if (!(pdfBlob instanceof Blob)) {
            console.error("Stored data is not a valid Blob:", pdfBlob);
            return;
        }

        const blobUrl = URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = blobUrl;

        const filename = await getReportDownloadFilename({
            blob: pdfBlob,
            reportName: selectedReport?.receipt_name,
            reportId: selectedReport?.receiptId,
        });
        link.setAttribute('download', filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
    }

    const handleArchiveClick = (receiptId) => {
        setReceiptId(receiptId);
        showPmrDeleteConfirm({
            html: '<div class="pmr-popup-message">You want to archive this receipt? It will remain archived for 30 days only, after which it will be permanently deleted.</div>',
            confirmText: 'Yes, archive it!',
        }).then((result) => {
            if (result.isConfirmed) {
                confirmArchive();
            }
        });
    };
    const handleDeleteClick = (receiptId) => {
        console.log(receiptId, "receiptId")
        setReceiptId(receiptId);



        showPmrDeleteConfirm({
            message: 'You want to delete this receipt? This action cannot be undone.',
        }).then((result) => {
            if (result.isConfirmed) {
                handleConfirmDelete();
            }
        });
    };

    const confirmArchive = () => {
        console.log('Archiving confirmed for:', receiptId);
        if (receiptId) {
            // Prepare params with the stored receipt ID
            const archiveParams = {
                token: token,
                UserID: selectedUserId,
                receiptId: receiptId
            };
            dispatch(archiveReceipts(archiveParams)).then((resp) => {
                console.log(resp, "resp for archiveReceipts");
                // Optionally: Refresh data or give feedback
                setReceiptId(null); // Clear the stored ID
                if (includeArchivedforReceipts) {
                    fetchArchivedReceipts();
                } else {
                    fetchReceipts();
                }
            }).catch(error => {
                console.error("Error archiving receipt:", error);
                setReceiptId(null); // Clear the stored ID on error too
            });
        }
    };

    const handleArchiveUndo = () => {
        const idToRestore = receiptId || selectedReport?.receiptId;
        if (!idToRestore) {
            console.error("No receipt selected to restore.");
            return;
        }
        const undoArchiveParams = {
            token: token,
            user_id: selectedUserId,
            receipt_id: idToRestore
        };
        dispatch(undoArchiveReceipts(undoArchiveParams)).then((resp) => {
            console.log(resp, "resp for undoArchiveReceipts");
            setReceiptId(null);
            setPdfBlob(null);
            setPdfUrl(null);
            setContentType(null);
            setSelectedReport(null);
            setSelectedRow(null);
            setShowUnarchiveSuccessModal(true);
            if (includeArchivedforReceipts) {
                fetchArchivedReceipts();
            } else {
                fetchReceipts();
            }
        }).catch((error) => {
            console.error("Error restoring receipt:", error);
            setReceiptId(null);
        });
    };
    const handleConfirmDelete = () => {
        console.log('Deleting confirmed for:', receiptId);
        if (receiptId) {
            // Prepare params with the stored receipt ID
            const deleteParams = {
                token: token,
                UserID: selectedUserId,
                receiptId: receiptId
            };
            dispatch(deleteReceipts(deleteParams)).then((resp) => {
                console.log(resp, "resp for deleteReceipts");
                setReceiptId(null); // Clear the stored ID
                setShowDeleteSuccessModal(true);
                if (includeArchivedforReceipts) {
                    fetchArchivedReceipts();
                } else {
                    fetchReceipts();
                }
            }).catch(error => {
                console.error("Error deleting receipt:", error);
                setReceiptId(null); // Clear the stored ID on error too
            });
        }
    };

    return (
        <div className="col-12">
            <ReportDisplaySection
                searchQuery={searchQuery}
                onSearchChange={(e) => onSearch(e)}
                onSearchClear={handleSearchClear}
                onAdvanceSearchClick={() => { }}
                onIncludeArchivedToggle={() => includeArchived()}
                onRefreshClick={() => onRefresh(activeTab)}
                gridHeaders={[]} // Empty array since receipts don't use tabs
                activeTab="All"
                onTabClick={() => { }}
                rowDatanew={rowDatanew}
                gridRef={gridRef}
                rowData={rowData}
                columnDefs={columnDefs}
                onRowClicked={onRowClicked}
                previewContainerRef={previewRef}
                isFullscreen={isFullscreen}
                pdfUrl={pdfUrl}
                isReportPreviewLoading={isReportPreviewLoading}
                selectedRow={selectedRow}
                selectedReport={selectedReport}
                selectedReportName={selectedReport?.receipt_name}
                selectedReportID={selectedReport?.receiptId}
                onFullScreenToggle={handleFullScreenToggle}
                onDeleteReport={(id) => handleDeleteClick(id)}
                onArchiveReport={(id) => handleArchiveClick(id)}
                onArchiveUndo={() => handleArchiveUndo()}
                onDownloadReport={downloadReceipt}
                onShareReport={() => { }}
                onEditReport={() => { }}
                iframeRef={iframeRef}
                onUploadReport={() => setShowUploadReciepts(true)}
                isSelectedBloodWork={false}
                onViewTrends={() => { }}
                onCompareReports={() => { }}
                isProvider={false}
                isAccess={false}
                contactName={null}
                handleNotes={() => { }}
                includeArchive={includeArchivedforReceipts}
                totalAmount={totalAmount}
                isFromReceipts={true}
                contentType={contentType}
                handleClear={handleClear}
                isReceipts={isReceipts}
                selectedFamilyMember={props.selectedFamilyMember}
            />

            <UploadReciepts
                show={showUploadReciepts}
                onHide={() => setShowUploadReciepts(false)}
                refreshReceipts={fetchReceipts}
                selectedFamilyMember={props.selectedFamilyMember}
            />
            {showDeleteSuccessModal && (
                <CustomSuccessModal
                    show={showDeleteSuccessModal}
                    onHide={() => setShowDeleteSuccessModal(false)}
                    message={"Receipt deleted successfully"}
                />
            )}
            {showUnarchiveSuccessModal && (
                <CustomSuccessModal
                    show={showUnarchiveSuccessModal}
                    onHide={() => setShowUnarchiveSuccessModal(false)}
                    message={"Receipt unarchived successfully"}
                />
            )}
        </div>
    );
};

export default Receipts;